<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
#app
  font-family 'Open Sans','Hiragino Sans GB','Lantinghei SC','Microsoft YaHei','STHeiti','WenQuanYi Micro Hei','PingFang SC','Helvetica Neue',Helvetica,Arial,sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #fff
  margin 0
</style>



// WEBPACK FOOTER //
// src/App.vue